import { createComponent } from '@carvana/merch-components';

export const CVTBannerContainer = createComponent('section', {
  className: `direction-row flex items-center rounded-md border border-grey-2 s:h-[53px] l:h-80`
});

export const ContentBlue = createComponent('div', {
  className: `flex h-full w-full justify-center rounded-md bg-blue-6 px-24 l:w-[198px] l:rounded-none l:rounded-l-md`
});

export const ContentWhite = createComponent('div', {
  className: `direction-row hidden w-full items-baseline justify-between rounded-r-lg bg-white px-24 text-blue-2 l:flex`
});

export const Divider = createComponent('span', {
  className: 'h-24 border border-grey-3 l:hidden'
});

export const MobileText = createComponent('span', {
  className:
    'w-full text-center text-sm font-semibold text-white s:whitespace-nowrap l:hidden'
});

export const DesktopText = createComponent('p', {
  className: 'hidden text-center text-2xl font-semibold text-blue-6 l:block'
});

export const DesktopCTA = createComponent('section', {
  className: `
      pointer
      hidden
      h-40
      w-[165px]
      rounded
      border
      border-blue-2 pt-[10px]
      text-center
      text-sm
      font-semibold
      uppercase
      text-blue-2
      hover:bg-blue-2
      hover:text-white
      l:block
      `
});
